export default __webpack_public_path__ + "static/media/prev-hybridshell.bd61b598.jpg";